import Typography from '@mui/material/Typography';
import ProfileAvatar from './ProfileAvatar';
import { imageProxy } from 'tf-post-parser';

export default function MiniAuthorProfileHeader(props) {
  const coverImage =
    props.data.coverImage && props.data.coverImage !== ''
      ? imageProxy(props.data.coverImage, 1500)
      : '';
  const divStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.1),rgba(0, 0, 0,0.5)),
        url("${coverImage}")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    height: '180px',
  };
  return (
    <div className="tw-text-center tw-py-6 tw-px-6" style={divStyle}>
      <div class="tw-flex tw-justify-center">
        <ProfileAvatar
          withBorder
          authorAvatar={props.data.profileImage}
          author={props.data.name}
          size={50}
        />
      </div>
      <Typography variant="h5" color="textPrimary" className="tw-text-white">
        {props.data.name && (
          <strong>
            {props.data.name === props.data.displayName
              ? `@${props.data.name}`
              : props.data.displayName}
          </strong>
        )}
        {props.data.isBlacklisted && (
          <>
            {' '}
            <span className="h5 pt-1 badge badge-danger">Blacklisted</span>
          </>
        )}
        {props.data.isCurator && (
          <>
            {' '}
            <span className="h5 pt-1 badge badge-success">Team</span>
          </>
        )}
      </Typography>
      {props.data.name && props.data.name !== props.data.displayName ? (
        <Typography
          variant="h6"
          color="textSecondary"
          className="tw-text-gray-100"
        >
          @{props.data.name}
        </Typography>
      ) : (
        <></>
      )}
    </div>
  );
}
